// Cookie holding the visitor's audience type resolved from the Demandbase company profile (set by header.js)
export const PERSONALIZATION_COOKIE_DEMANDBASE = 'demandbase_personalization';

export const PERSONALIZATION_AUDIENCE = {
    SP: 'SP',
    CORP_EDUCATION: 'Corp-Education',
    CORP_HEALTHCARE: 'Corp-Healthcare',
    CORP_PHARMA: 'Corp-Pharma',
    CORP_TELECOM: 'Corp-Telecom',
    CORP_OT: 'Corp-OT',
} as const;

export type PersonalizationAudience = typeof PERSONALIZATION_AUDIENCE[keyof typeof PERSONALIZATION_AUDIENCE];
